module.exports = __webpack_public_path__ + "img/2024wca2.a7a1eb53.jpg";